import * as actions from '@/domain/organization/organizationActions';
import { organizationAdapter, signerFactory, signingsFactory } from '@/domain/organization/helpers';

export const reducer = {
  organization(state = organizationAdapter(), action) {
    switch (action.type) {
      case actions.setOrganization.success: {
        const { currentOrganization, sort, expiration_days } = state;

        return state
          .mergeDeep(action.payload)
          .set('ip_whitelist', action.payload.ip_whitelist)
          .set('currentOrganization', currentOrganization)
          .set('sort', sort)
          .set('expiration_days', expiration_days)
          .update('list', (list) =>
            list.map((org) =>
              org.id !== action.payload.id
                ? org
                : org.merge({ picture: action.payload.picture, name: action.payload.name }),
            ),
          );
      }

      case actions.uploadLogoOrganization.success:
        return state.set('picture', action.payload.picture);

      case actions.getOrganizationSignings.success:
        return state.set('signings', action.payload);

      case actions.getOrganizationFeatures.success:
        return state.set('features', action.payload);

      case actions.setOrganizationFeaturesAction.success:
        return state.set('features', action.payload);

      case actions.getOrgBackupConnections.success:
        return state.set('backupConnection', action.payload);

      case actions.removeAllOrganizationSignerAction.success:
        return state.set('signings', signingsFactory());

      case actions.clearOrganization.type:
        return organizationAdapter();

      case actions.addEmptyOrganizationSignerAction.type:
        return state.updateIn(['signings', 'tokens'], (s) => s.push(signerFactory()));

      case actions.updateOrganizationSigningsAction.success:
        return state.updateIn(['signings', 'tokens'], (s) => s.push(action.payload).filter((i) => i.token_name));

      case actions.setOrganizationSigningsGuidAction.success:
        return state.setIn(['signings', 'guid'], action.payload);

      case actions.removeOrganizationSignerAction.success:
        return state.updateIn(['signings', 'tokens'], (s) => {
          if (action.payload.tokenName) {
            return s.filter((i) => i.token_name !== action.payload.tokenName);
          }
          return s.filter((i, idx) => idx !== action.payload.idx);
        });

      case actions.getOrganizationList.success:
        return state.set('list', action.payload).set('loaded', true);

      case actions.setOrganizationsFilter.type:
        return state.set('filter', action.payload || '');

      case actions.setOrganizationsSort.type:
        return state.set('sort', action.payload);

      case actions.setCurrentOrganization.type:
        return state.set('currentOrganization', action.payload);

      case actions.unsetCurrentOrganization.type:
        return state.set('currentOrganization', null);

      case actions.getPasswordExpirationAction.success:
        return state.set('expiration_days', action.payload);

      default:
        return state;
    }
  },
};
